// Centralized route metadata used for layout and integrations

// Public (unauthenticated) routes
export const PUBLIC_ROUTE_PATHS = [
  '/login', '/cara_login', '/tprm_login', '/tprm_user_login', '/vrm_login', '/offsec_staff_login', '/superadmin_login', '/internal_staff_login', '/internal_staff_login',
  '/otp', '/ota', '/reset_password', '/set_password', '/expired-link', '/book_demo', '/404'
];

// OffSec Staff Portal pages (login excluded). Every one of them brings its own
// sidebar/header - without hiding the CARA ones, the CARA header, sidebar and
// timezone banner also mounted behind the staff UI (and the CARA header's
// user lookups 404'd for staff).
export const OFFSEC_STAFF_PORTAL_ROUTES = [
  '/offsec_staff_dashboard', '/offsec_staff_settings', '/offsec_staff_findings',
  '/offsec_staff_overview', '/offsec_staff_engagements', '/offsec_staff_remediation', '/offsec_staff_revalidation',
  '/offsec_staff_reports', '/offsec_staff_schedule', '/offsec_staff_clients', '/offsec_staff_activity',
];

// Routes where the sidebar should be hidden
export const HIDE_SIDEBAR_ROUTES = [
  '/login', '/404', '/ota', '/reset_password', '/tprm_user_login', '/expired-link', '/set_password',
  '/tprm_login', '/vrm_login', '/offsec_staff_login', '/superadmin_login', '/internal_staff_login', '/example', '/otp', '/cara_login',
  ...OFFSEC_STAFF_PORTAL_ROUTES,
];

// Routes that hide the shared CARA sidebar but render their own. They still
// follow the standard behaviour of starting with the sidebar collapsed.
export const OWN_SIDEBAR_ROUTES = OFFSEC_STAFF_PORTAL_ROUTES;

// Routes where the session timeout modal should be skipped
export const SKIP_SESSION_MODAL_PREFIXES = ['/set_password', '/reset_password', '/expired-link'];

// Routes to exclude Tawk.to chat widget
export const EXCLUDED_CHAT_ROUTES = [
  '/login', '/', '/ota', '/otp', '/404', '/cara_login', '/tprm_login', '/vrm_login', '/offsec_staff_login', '/tprm_user_login', '/superadmin_login', '/internal_staff_login'
];
